import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StatesService extends BaseService {
  override baseUrl = `${environment.apiUrl}/entities`;

  getStates() {
    return this.http.post<any>(this.baseUrl, null);
  }

  getMunicipalities(stateId: number) {
    return this.http.post<any>(this.baseUrl, {
      only_municipal: true,
      state_ids: [stateId]
    });
  }
}
